import { FormEvent, useState } from 'react';
import { importDictionary } from '../../api';
import Loader from '../../components/Loader';
import './index.scss';

const AdminPage = () => {
  const [password, setPassword] = useState('');
  const [file, setFile] = useState<File | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [errors, setErrors] = useState<string[]>([]);

  const resetMessages = () => {
    setSuccess('');
    setError('');
    setErrors([]);
  };

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    resetMessages();

    if (!password) {
      setError('Podaj hasło.');
      return;
    }

    if (!file) {
      setError('Wybierz plik .xlsx.');
      return;
    }

    setIsLoading(true);
    try {
      const response = await importDictionary(file, password);
      if (response.status === 401) {
        setError(response.data?.message || 'Nieprawidłowe hasło.');
        return;
      }

      if (response.status >= 400) {
        setError(response.data?.message || 'Import nie powiódł się.');
        setErrors(Array.isArray(response.data?.errors) ? response.data.errors : []);
        return;
      }

      setSuccess(`Zaimportowano ${response.data.imported} pozycji.`);
    } catch {
      setError('Nie udało się połączyć z serwerem.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className='admin-page'>
      {isLoading && <Loader />}
      <div className='container'>
        <h1 className='title'>Panel administratora</h1>
        <p className='admin-page__subtitle'>
          Wgraj plik Excel ze słownikiem pojazdów i zaktualizuj dane w bazie.
        </p>
        <form className='admin-page__form' onSubmit={handleSubmit}>
          <label className='admin-page__field'>
            <span>Hasło</span>
            <input
              type='password'
              autoComplete='current-password'
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </label>
          <label className='admin-page__field'>
            <span>Plik .xlsx</span>
            <input
              type='file'
              accept='.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
              onChange={(event) => setFile(event.target.files?.[0] ?? null)}
            />
          </label>
          <button className='button' type='submit' disabled={isLoading}>
            Zaktualizuj dane
          </button>
        </form>
        {success && <p className='admin-page__success'>{success}</p>}
        {error && <p className='admin-page__error'>{error}</p>}
        {errors.filter((item) => item !== error).length > 0 && (
          <ul className='admin-page__errors'>
            {errors.filter((item) => item !== error).map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default AdminPage;
